import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

export const FeedbackProductItemSchema = z.object({
  Id: z.string(),
  Created: DateValidation,
  Name: z.string().optional(),
  Title: z.string().optional(),
  Email: z.string().optional(),
  ProductId: z.string().optional(),
  Rating: z.number().optional(),
  Text: z.string().optional(),
});

export type FeedbackProductItemType = z.infer<typeof FeedbackProductItemSchema>;
